import { BaseDataService } from "../../../services/base/BaseDataService";
import { TaskActionDto } from "../../../types/requests/TaskActionDto";
import { UserTask } from "../models/UserTask";
import { UserTaskQuery } from "../models/UserTaskQuery";


export class UserTaskService extends BaseDataService<UserTask, UserTaskQuery> {
  protected prefixUrl: string = `UserTasks`;

  completeTask(taskId: number, wfInstanceId: number, approved: boolean) {
    const dto: TaskActionDto = {
      TaskId: taskId,
      WfInstanceId: wfInstanceId,
      Approved: approved,
      Comment: ""
    };

    return this.api.post<boolean>(`${this.prefixUrl}/CompleteTask`, dto);
  }
}
